import React, { useState, useEffect } from 'react';
import config from '../config';

import { useNavigate } from 'react-router-dom';
import { 
    Search, ArrowRight, Download, X, Plus, 
    Calendar, FileSpreadsheet, Check, ChevronRight, 
    ChevronLeft, Trash2, Loader
} from 'lucide-react';
import * as XLSX from 'xlsx';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';


// عدسة تكبير للصورة (نفس الفكرة بتاعة صفحة الجوازات)
const ImageMagnifier = ({
  src,
  alt,
  className = "",
  magnifierHeight = 200,
  magnifierWidth = 200,
  zoomLevel = 1.8,
}) => {
  const [showMagnifier, setShowMagnifier] = useState(false);
  const [magnifierXY, setMagnifierXY] = useState({ x: 0, y: 0 });
  const [imgXY, setImgXY] = useState({ x: 0, y: 0 });
  const [imgSize, setImgSize] = useState({ width: 0, height: 0 });

  const handleMouseMove = (e) => {
    const elem = e.currentTarget;
    const { top, left, width, height } = elem.getBoundingClientRect();

    // مكان الماوس جوّا الصورة
    const x = e.clientX - left;
    const y = e.clientY - top;

    setImgXY({ x, y });
    setImgSize({ width, height });

    // مكان عدسة التكبير
    setMagnifierXY({
      x: e.clientX - magnifierWidth / 2,
      y: e.clientY - magnifierHeight / 2,
    });
  };

  if (!src) return null;

  return (
    <div className="relative inline-block w-full h-full">
      <img
        src={src}
        alt={alt}
        className={`${className} cursor-crosshair`}
        onMouseEnter={() => setShowMagnifier(true)}
        onMouseLeave={() => setShowMagnifier(false)}
        onMouseMove={handleMouseMove}
      />

      {/* عدسة التكبير */}
      {showMagnifier && (
        <div
          className="fixed border-4 border-gray-800 rounded-full pointer-events-none z-[999] shadow-2xl bg-white overflow-hidden"
          style={{
            height: `${magnifierHeight}px`,
            width: `${magnifierWidth}px`,
            top: `${magnifierXY.y}px`,
            left: `${magnifierXY.x}px`,
            backgroundImage: `url('${src}')`,
            backgroundRepeat: "no-repeat",
            backgroundSize: `${imgSize.width * zoomLevel}px ${
              imgSize.height * zoomLevel
            }px`,
            backgroundPositionX: `${
              -imgXY.x * zoomLevel + magnifierWidth / 2
            }px`,
            backgroundPositionY: `${
              -imgXY.y * zoomLevel + magnifierHeight / 2
            }px`,
          }}
        >
          {/* خطوط التقاطع */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="w-full h-0.5 bg-red-500 opacity-70" />
          </div>
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <div className="h-full w-0.5 bg-red-500 opacity-70" />
          </div>

          {/* مستوى التكبير */}
          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-black text-white text-xs px-2 py-1 rounded">
            {zoomLevel}x
          </div>
        </div>
      )}
    </div>
  );
};


// دالة بناء رابط صورة الجواز (نفس اللي شغّالة في صفحة الجوازات)
const buildImageUrl = (imagePath) => {
    // حماية من القيم الغلط
    if (
        !imagePath ||
        imagePath === null ||
        imagePath === undefined ||
        typeof imagePath !== 'string' ||
        imagePath.trim() === ''
    ) {
        console.warn('مسار صورة غير صحيح:', imagePath);
        return null;
    }

    try {
        // لو المسار فيه year/month/folder/filename (النظام الجديد)
        if (imagePath.includes('/')) {
            const parts = imagePath.split('/').filter(part => part && part.trim() !== '');
            if (parts.length >= 4) {
                const year = parts[0];
                const month = parts[1];
                const folder = parts[2];
                const filename = parts[3];

                // تحويل اسم المجلد لنوع الصورة
                const typeMap = {
                    'passport_images': 'passport',
                    'personal_images': 'personal',
                    'license_images': 'license',
                    'id_images': 'id'
                };

                const type = typeMap[folder] || 'passport';

                return `${config.PASSPORT_API_URL}/api/passports/images/${year}/${month}/${type}/${filename}`;
            }
        }

        // لو المسار قديم (بس اسم الملف بس)
        return `${config.PASSPORT_API_URL}/api/passports/images/passport/${imagePath}`;
    } catch (error) {
        console.error('خطأ في بناء رابط الصورة:', error);
        return null;
    }
};




const FlightReport = () => {
    const navigate = useNavigate();
    
    // متغيرات الحالة الأساسية
    const [search, setSearch] = useState('');
    const [passports, setPassports] = useState([]);
    const [filteredPassports, setFilteredPassports] = useState([]);
    const [selectedPassports, setSelectedPassports] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [companyFilter, setCompanyFilter] = useState('');
    const [dateFilterType, setDateFilterType] = useState('visa'); // 'visa' | 'consulate' | 'travel'
    const [consulateStartDate, setConsulateStartDate] = useState('');
    const [consulateEndDate, setConsulateEndDate] = useState('');
    const [travelStartDate, setTravelStartDate] = useState('');
    const [travelEndDate, setTravelEndDate] = useState('');
const [companies, setCompanies] = useState([]);




    // متغيرات التصدير
// متغيرات التصدير
const [exportColumns, setExportColumns] = useState({
    serialNumber: true,
    nameArabic: true,
    nameEnglish: true,
    passportNumber: true,
    nationalId: true,
    delegateName: true,       // ✅ المندوب
    militaryStatus: true,     // ✅ الموقف من التجنيد
    phoneNumber: true,
    visaDate: true,
    travelDate: true
});

    const [showExportModal, setShowExportModal] = useState(false);

    // متغيرات كشوفات الطيران
    const [savedLists, setSavedLists] = useState([]);
    const [showSaveListModal, setShowSaveListModal] = useState(false);
    const [showSavedLists, setShowSavedLists] = useState(true);
    const [newListData, setNewListData] = useState({
        listName: '',
        flightDate: '',
        notes: ''
    });
    const [currentList, setCurrentList] = useState(null);

    // متغيرات عرض الصور
    const [selectedImage, setSelectedImage] = useState(null);
    const [showImageViewer, setShowImageViewer] = useState(false);

    // متغيرات حالة النظام
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);




    // دوال الرسائل والإشعارات
    const showSuccessMessage = (message) => {
        setSuccessMessage(message);
        setTimeout(() => setSuccessMessage(null), 3000);
    };

    const showErrorMessage = (message) => {
        setErrorMessage(message);
        setTimeout(() => setErrorMessage(null), 3000);
    };

    useEffect(() => {
        fetchPassports();
        fetchSavedLists();
        fetchCompanies();
    }, []);


    // جلب قائمة الشركات لاستخدامها فى الفلتر
const fetchCompanies = async () => {
    try {
        const response = await fetch(`${config.PASSPORT_API_URL}/api/companies`);
        if (!response.ok) throw new Error('فشل في جلب الشركات');
        const data = await response.json();

        // لو الـ API راجعة Array مباشرة أو جوّه data
        if (Array.isArray(data)) {
            setCompanies(data);
        } else if (Array.isArray(data.data)) {
            setCompanies(data.data);
        } else {
            setCompanies([]);
        }
    } catch (error) {
        console.error('خطأ في جلب الشركات:', error);
        setCompanies([]);
    }
};


    // دالة جلب الجوازات
const fetchPassports = async () => {
    // safety: لو حصل أي مشكلة مش متوقعة، نشيل الـ loading بعد 15 ثانية
    const safetyTimer = setTimeout(() => setIsLoading(false), 15000);
    try {
        setIsLoading(true);
        const response = await fetch(`${config.FLIGHT_API_URL}/api/passports`);
        if (!response.ok) throw new Error('فشل في جلب البيانات');
        const data = await response.json();

        // نخزن كل الجوازات فى الذاكرة فقط
        setPassports(data);

        // لكن ما نعرضش أى نتيجة فى البداية
        setFilteredPassports([]);
    } catch (error) {
        showErrorMessage('خطأ في جلب البيانات: ' + error.message);
    } finally {
        clearTimeout(safetyTimer);
        setIsLoading(false);
    }
};




    // دالة جلب الكشوفات المحفوظة
    const fetchSavedLists = async () => {
        try {
            const response = await fetch(`${config.FLIGHT_API_URL}/api/flight-lists`);
            if (!response.ok) throw new Error('فشل في جلب الكشوفات');
            const data = await response.json();
            setSavedLists(data);
        } catch (error) {
            showErrorMessage('خطأ في جلب الكشوفات: ' + error.message);
        }
    };




    
    // دالة البحث مع فلتر التاريخ (تأشير / قنصلية / سفر) + الشركة
const handleSearch = (
    searchTerm,
    start = startDate,
    end = endDate,
    companyId = companyFilter,
    filterType = dateFilterType,
    cStart = consulateStartDate,
    cEnd = consulateEndDate,
    tStart = travelStartDate,
    tEnd = travelEndDate
) => {
    setSearch(searchTerm);

    // تحديد نطاق التاريخ النشط حسب نوع الفلتر
    let activeStart, activeEnd, activeDateField;
    if (filterType === 'consulate') {
        activeStart = cStart;
        activeEnd = cEnd;
        activeDateField = 'ConsulateEntryDate';
    } else if (filterType === 'travel') {
        activeStart = tStart;
        activeEnd = tEnd;
        activeDateField = 'TravelDate';
    } else {
        activeStart = start;
        activeEnd = end;
        activeDateField = 'VisaDate';
    }

    // لو مفيش نطاق تاريخ محدد → مافيش نتائج
    if (!activeStart || !activeEnd) {
        setFilteredPassports([]);
        return;
    }

    const lower = (searchTerm || '').toLowerCase();
    const effectiveCompanyId = companyId || companyFilter;

    // فلترة حسب النص (لو مكتوب)
    let filtered = passports.filter(passport => {
        if (!searchTerm) return true;
        return (
            passport.NameArabic?.toLowerCase().includes(lower) ||
            passport.PassportNumber?.toLowerCase().includes(lower) ||
            passport.NationalID?.includes(searchTerm) ||
            passport.SerialNumber?.includes(searchTerm)
        );
    });

    // فلترة بنطاق التاريخ المحدد
    const startDateTime = new Date(activeStart);
    const endDateTime = new Date(activeEnd);

    filtered = filtered.filter(passport => {
        const dateVal = passport[activeDateField];
        if (!dateVal) return false;
        const d = new Date(dateVal);
        return d >= startDateTime && d <= endDateTime;
    });

    // فلترة الشركة
    if (effectiveCompanyId) {
        filtered = filtered.filter(passport =>
            passport.CompanyID?.toString() === effectiveCompanyId
        );
    }

    setFilteredPassports(filtered);
};




    // دالة إضافة جواز إلى القائمة المحددة
    const handleAddPassport = (passport) => {
        if (!selectedPassports.find(p => p.PassportID === passport.PassportID)) {
            setSelectedPassports(prev => [...prev, passport]);
            showSuccessMessage(`تم إضافة ${passport.NameArabic} إلى القائمة`);
        }
    };

    // دالة إزالة جواز من القائمة المحددة
    const handleRemovePassport = (passportId) => {
        setSelectedPassports(prev => prev.filter(p => p.PassportID !== passportId));
    };

    // دالة إزالة كل الجوازات المحددة
    const handleClearAll = () => {
        if (selectedPassports.length === 0) return;
        if (window.confirm('هل أنت متأكد من إزالة كل الجوازات المحددة؟')) {
            setSelectedPassports([]);
            showSuccessMessage('تم إزالة كل الجوازات من القائمة');
        }
    };

    // دالة إضافة كل الجوازات المفلترة
    const handleAddAllFiltered = () => {
        const newPassports = filteredPassports.filter(
            passport => !selectedPassports.find(p => p.PassportID === passport.PassportID)
        );
        if (newPassports.length > 0) {
            setSelectedPassports(prev => [...prev, ...newPassports]);
            showSuccessMessage(`تم إضافة ${newPassports.length} جواز إلى القائمة`);
        } else {
            showErrorMessage('جميع الجوازات مضافة بالفعل');
        }
    };

    // دالة تصدير إلى Excel
    const exportToExcel = () => {
        if (selectedPassports.length === 0) {
            showErrorMessage('الرجاء اختيار جوازات للتصدير');
            return;
        }

        try {
            const exportData = selectedPassports.map((passport, index) => {
                const row = {};

                if (exportColumns.serialNumber) {
                    row['Serial number'] = index + 1;
                }
                if (exportColumns.nameArabic) {
                    row['الاسم بالعربي'] = passport.NameArabic;
                }
                if (exportColumns.nameEnglish) {
                    const nameParts = passport.NameEnglish ? passport.NameEnglish.split(' ') : ['', '', ''];
                    row['First Name'] = nameParts[0] || '';
                    row['Second Name'] = nameParts[1] || '';
                    row['Last Name'] = nameParts[nameParts.length - 1] || '';
                }
                if (exportColumns.passportNumber) {
                    row['Passport No.'] = passport.PassportNumber;
                }
                if (exportColumns.nationalId) {
                    row['الرقم القومي'] = passport.NationalID;
                }
                    if (exportColumns.delegateName) {
            row['المندوب'] = passport.DelegateName || '';
        }
        if (exportColumns.militaryStatus) {
            row['الموقف من التجنيد'] = passport.MilitaryStatus || '';
        }

                if (exportColumns.phoneNumber) {
                    row['Phone Number'] = JSON.parse(passport.PhoneNumbers || '[]')[0] || '';
                }
                if (exportColumns.visaDate) {
                    row['تاريخ التأشير'] = passport.VisaDate ? 
                        new Date(passport.VisaDate).toLocaleDateString('ar-EG') : '';
                }
                if (exportColumns.travelDate) {
                    row['تاريخ السفر'] = passport.TravelDate ? 
                        new Date(passport.TravelDate).toLocaleDateString('ar-EG') : '';
                }

                return row;
            });

            // إنشاء ورقة عمل
            const ws = XLSX.utils.json_to_sheet(exportData);
            applyExcelStyles(ws, exportData.length);

            // إنشاء وتحميل الملف
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "كشف الطيران");

            const fileName = currentList 
                ? `كشف_طيران_${currentList.ListName}_${new Date().toLocaleDateString('ar-EG')}.xlsx`
                : `كشف_طيران_${new Date().toLocaleDateString('ar-EG')}.xlsx`;

            XLSX.writeFile(wb, fileName, {
                bookType: 'xlsx',
                bookSST: false,
                type: 'binary',
                cellStyles: true
            });

            showSuccessMessage('تم تصدير الملف بنجاح');
        } catch (error) {
            showErrorMessage('حدث خطأ أثناء التصدير: ' + error.message);
        }
    };

    // دالة تصدير كل صور الجوازات المختارة كمجلد مضغوط ZIP
    const exportPassportImages = async () => {
        if (!selectedPassports || selectedPassports.length === 0) {
            showErrorMessage('الرجاء اختيار جوازات أولاً لتصدير الصور');
            return;
        }

        try {
            const zip = new JSZip();
            const folder = zip.folder('صور الجوازات');

            // نحضّر كل طلبات الصور
            const tasks = selectedPassports.map(async (passport, index) => {
                if (!passport.PassportImagePath) return;

                const imageUrl = buildImageUrl(passport.PassportImagePath);
                if (!imageUrl) return;

                const response = await fetch(imageUrl);
                if (!response.ok) return;

                const blob = await response.blob();
                const arrayBuffer = await blob.arrayBuffer();

                // اسم ملف آمن
                const safeName = (passport.NameArabic || `جواز_${index + 1}`)
                    .replace(/[\\/:*?"<>|]/g, '_');

                folder.file(`صورة_جواز_${safeName}.jpg`, arrayBuffer);
            });

            await Promise.all(tasks);

            // لو مفيش ولا صورة اتضافت
            if (!folder || Object.keys(folder.files || {}).length === 0) {
                showErrorMessage('لا توجد صور متاحة للجوازات المحددة');
                return;
            }

            // اسم الملف المضغوط بالتاريخ
            const today = new Date();
            const yyyy = today.getFullYear();
            const mm = String(today.getMonth() + 1).padStart(2, '0');
            const dd = String(today.getDate()).padStart(2, '0');
            const fileName = `صور جوازات كشف الطيران - ${yyyy}-${mm}-${dd}.zip`;

            const zipBlob = await zip.generateAsync({ type: 'blob' });
            saveAs(zipBlob, fileName);

            showSuccessMessage(`تم إنشاء ملف مضغوط لصور الجوازات (${fileName})`);
        } catch (error) {
            console.error('خطأ أثناء إنشاء ملف ZIP:', error);
            showErrorMessage('حدث خطأ أثناء إنشاء ملف مضغوط لصور الجوازات');
        }
    };




    // دالة تطبيق أنماط Excel
    const applyExcelStyles = (ws, rowCount) => {
        const headerStyle = {
            font: { 
                bold: true, 
                sz: 14,
                color: { rgb: "000000" }
            },
            alignment: { 
                horizontal: 'center', 
                vertical: 'center',
                wrapText: true 
            },
            fill: { 
                fgColor: { rgb: "FFFF00" },
                patternType: "solid" 
            },
            border: {
                top: { style: 'medium', color: { rgb: "000000" } },
                bottom: { style: 'medium', color: { rgb: "000000" } },
                left: { style: 'medium', color: { rgb: "000000" } },
                right: { style: 'medium', color: { rgb: "000000" } }
            }
        };

        const cellStyle = {
            font: { 
                sz: 12,
                color: { rgb: "000000" } 
            },
            alignment: { 
                horizontal: 'center', 
                vertical: 'center',
                wrapText: true 
            },
            border: {
                top: { style: 'thin', color: { rgb: "000000" } },
                bottom: { style: 'thin', color: { rgb: "000000" } },
                left: { style: 'thin', color: { rgb: "000000" } },
                right: { style: 'thin', color: { rgb: "000000" } }
            }
        };

        const serialNumberStyle = {
            ...cellStyle,
            font: { 
                bold: true,
                sz: 14,
                color: { rgb: "000000" }
            },
            fill: { 
                fgColor: { rgb: "FFFF00" },
                patternType: "solid" 
            }
        };

        // تعيين عرض الأعمدة
        const wscols = [];
        if (exportColumns.serialNumber) wscols.push({ wch: 15 });
        if (exportColumns.nameArabic) wscols.push({ wch: 30 });
        if (exportColumns.nameEnglish) {
            wscols.push({ wch: 20 }); // First Name
            wscols.push({ wch: 20 }); // Second Name
            wscols.push({ wch: 20 }); // Last Name
        }
        if (exportColumns.passportNumber) wscols.push({ wch: 20 });
        if (exportColumns.nationalId) wscols.push({ wch: 20 });
        if (exportColumns.phoneNumber) wscols.push({ wch: 20 });
        if (exportColumns.visaDate) wscols.push({ wch: 20 });
        if (exportColumns.travelDate) wscols.push({ wch: 20 });

        ws['!cols'] = wscols;
        ws['!rows'] = [{ hpt: 40 }]; // ارتفاع أكبر للعناوين

        // تطبيق الأنماط على كل خلية
        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cell_address = { c: C, r: R };
                const cell_ref = XLSX.utils.encode_cell(cell_address);

                if (!ws[cell_ref]) continue;

                if (R === 0) {
                    ws[cell_ref].s = headerStyle;
                } else {
                    if (exportColumns.serialNumber && C === 0) {
                        ws[cell_ref].s = serialNumberStyle;
                    } else {
                        ws[cell_ref].s = cellStyle;
                    }
                }
            }
        }
    };

    // دالة حفظ كشف جديد
    const handleSaveList = async () => {
        try {
            if (!newListData.listName || !newListData.flightDate) {
                showErrorMessage('الرجاء إدخال اسم الكشف وتاريخ الطيران');
                return;
            }

            if (selectedPassports.length === 0) {
                showErrorMessage('الرجاء اختيار جوازات للكشف');
                return;
            }

            setIsLoading(true);
            const response = await fetch(`${config.FLIGHT_API_URL}/api/flight-lists`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...newListData,
                    passportIds: selectedPassports.map(p => p.PassportID)
                })
            });

            if (!response.ok) {
                throw new Error('فشل في حفظ الكشف');
            }

            const result = await response.json();
            setShowSaveListModal(false);
            setNewListData({ listName: '', flightDate: '', notes: '' });
            await fetchSavedLists();
            showSuccessMessage('تم حفظ الكشف بنجاح');
        } catch (error) {
            showErrorMessage('حدث خطأ أثناء حفظ الكشف: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };
    // دالة تحميل كشف محفوظ
    const loadList = async (listId) => {
        const safetyTimer = setTimeout(() => setIsLoading(false), 15000);
        try {
            setIsLoading(true);
            const response = await fetch(`${config.FLIGHT_API_URL}/api/flight-lists/${listId}`);
            if (!response.ok) throw new Error('فشل في تحميل الكشف');
            
            const data = await response.json();
            setCurrentList(data.listInfo);
            setSelectedPassports(data.passports);
            setNewListData({
                listName: data.listInfo.ListName,
                flightDate: new Date(data.listInfo.FlightDate).toISOString().split('T')[0],
                notes: data.listInfo.Notes
            });

            showSuccessMessage('تم تحميل الكشف بنجاح');
        } catch (error) {
            showErrorMessage('خطأ في تحميل الكشف: ' + error.message);
        } finally {
            clearTimeout(safetyTimer);
            setIsLoading(false);
        }
    };

    // دالة تحديث كشف موجود
    const handleUpdateList = async () => {
        try {
            if (!currentList) return;
            if (!newListData.listName || !newListData.flightDate) {
                showErrorMessage('الرجاء إدخال جميع البيانات المطلوبة');
                return;
            }

            setIsLoading(true);
            const response = await fetch(`${config.FLIGHT_API_URL}/api/flight-lists/${currentList.ListID}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ...newListData,
                    passportIds: selectedPassports.map(p => p.PassportID)
                })
            });

            if (!response.ok) throw new Error('فشل في تحديث الكشف');

            await fetchSavedLists();
            showSuccessMessage('تم تحديث الكشف بنجاح');
            setShowSaveListModal(false);
        } catch (error) {
            showErrorMessage('خطأ في تحديث الكشف: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    // دالة حذف كشف
    const handleDeleteList = async (listId) => {
        if (!window.confirm('هل أنت متأكد من حذف هذا الكشف؟')) return;

        try {
            setIsLoading(true);
            const response = await fetch(`${config.FLIGHT_API_URL}/api/flight-lists/${listId}`, {
                method: 'DELETE'
            });

            if (!response.ok) throw new Error('فشل في حذف الكشف');

            await fetchSavedLists();
            if (currentList?.ListID === listId) {
                setCurrentList(null);
                setSelectedPassports([]);
                setNewListData({ listName: '', flightDate: '', notes: '' });
            }
            showSuccessMessage('تم حذف الكشف بنجاح');
        } catch (error) {
            showErrorMessage('خطأ في حذف الكشف: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    // مكونات الواجهة المساعدة
    const LoadingOverlay = () => (
        isLoading && (
            <div className="fixed inset-0 z-40 flex items-center justify-center pointer-events-none">
                <div className="bg-white p-4 rounded-lg flex items-center gap-3 shadow-xl pointer-events-auto border border-gray-200">
                    <Loader className="animate-spin text-blue-600" />
                    <span>جاري التحميل...</span>
                </div>
            </div>
        )
    );

    const AlertMessage = ({ type, message }) => (
        <div className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 transition-all duration-300 ${
            type === 'success' ? 'bg-green-500' : 'bg-red-500'
        } text-white`}>
            {message}
        </div>
    );

        // مكون واجهة المستخدم الرئيسي
    return (
        <div className={`min-h-screen bg-gray-100 py-6 transition-all duration-300 ${showSavedLists ? 'mr-[400px]' : ''}`}>
            {/* رسائل النظام */}
            {successMessage && <AlertMessage type="success" message={successMessage} />}
            {errorMessage && <AlertMessage type="error" message={errorMessage} />}
            {isLoading && <LoadingOverlay />}

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* رأس الصفحة */}
                <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                    <div className="flex justify-between items-center">
                        <h1 className="text-3xl font-bold text-gray-900">كشف الطيران</h1>
                        <div className="flex items-center gap-4">
                            <button 
                                onClick={() => navigate('/reports')}
                                className="relative z-50 flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg transition-colors"
                            >
                                <ArrowRight className="w-5 h-5" />
                                العودة للكشوفات
                            </button>
                        </div>
                    </div>
                </div>

                {/* قسم البحث والتصفية */}
                <div className="bg-white rounded-lg shadow-md p-6 mb-6">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {/* البحث */}
                        <div className="relative">
                            <Search className="absolute right-3 top-3 text-gray-400" />
                            <input
                                type="text"
                                placeholder="البحث بالاسم أو رقم الجواز أو الرقم القومي..."
                                value={search}
                                onChange={(e) => handleSearch(e.target.value)}
                                className="w-full border border-gray-300 rounded-lg py-2 px-10 focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* تحديد الفترة */}
                        <div className="flex gap-4">

<div className="flex-[1.4] w-full min-w-[230px]">
    <label className="block text-sm font-medium text-gray-700 mb-1">
        الشركة
    </label>
    <select
        value={companyFilter}
        onChange={(e) => {
            const value = e.target.value;
            setCompanyFilter(value);
            handleSearch(search, startDate, endDate, value);
        }}
        className="w-full h-[44px] border border-gray-300 rounded-lg px-3 text-sm bg-white
                   focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    >
        <option value="">كل الشركات</option>
        {companies.map((company) => (
            <option key={company.CompanyID} value={company.CompanyID}>
                {company.CompanyName}
            </option>
        ))}
    </select>
</div>

                            {/* نوع فلتر التاريخ */}
                            <div className="flex-[1.4] w-full min-w-[200px]">
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    فلتر التاريخ حسب
                                </label>
                                <div className="flex rounded-lg border border-gray-300 overflow-hidden h-[44px]">
                                    {[
                                        { value: 'visa',      label: 'التأشير' },
                                        { value: 'consulate', label: 'القنصلية' },
                                        { value: 'travel',    label: 'السفر' }
                                    ].map(({ value, label }) => (
                                        <button
                                            key={value}
                                            onClick={() => {
                                                setDateFilterType(value);
                                                handleSearch(
                                                    search,
                                                    startDate, endDate,
                                                    companyFilter,
                                                    value,
                                                    consulateStartDate, consulateEndDate,
                                                    travelStartDate, travelEndDate
                                                );
                                            }}
                                            className={`flex-1 text-xs font-medium transition-colors
                                                ${dateFilterType === value
                                                    ? 'bg-blue-600 text-white'
                                                    : 'bg-white text-gray-600 hover:bg-blue-50'
                                                }`}
                                        >
                                            {label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* حقلا التاريخ - يتغيران حسب النوع المختار */}
                            {dateFilterType === 'visa' && (
                                <>
                                    <div className="flex-1">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            من تاريخ التأشير
                                        </label>
                                        <input
                                            type="date"
                                            value={startDate}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setStartDate(value);
                                                handleSearch(search, value, endDate, companyFilter, 'visa');
                                            }}
                                            className="w-full border border-gray-300 rounded-lg p-2"
                                        />
                                    </div>
                                    <div className="flex-1 w-full flex items-end gap-2">
                                        <div className="flex-1">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                إلى تاريخ التأشير
                                            </label>
                                            <input
                                                type="date"
                                                value={endDate}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setEndDate(value);
                                                    handleSearch(search, startDate, value, companyFilter, 'visa');
                                                }}
                                                className="w-full border border-gray-300 rounded-lg p-2"
                                            />
                                        </div>
                                        <div className="flex items-end gap-2">
                                          <button onClick={() => setShowExportModal(true)} disabled={selectedPassports.length === 0}
                                            className={`px-3 py-2 rounded-lg flex items-center justify-center gap-2 text-sm whitespace-nowrap ${selectedPassports.length === 0 ? 'bg-gray-300 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'} text-white`}>
                                            <FileSpreadsheet className="w-4 h-4" /><span>تصدير إكسل</span>
                                          </button>
                                          <button onClick={exportPassportImages} disabled={selectedPassports.length === 0}
                                            className={`px-3 py-2 rounded-lg flex items-center justify-center gap-2 text-sm whitespace-nowrap ${selectedPassports.length === 0 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'} text-white`}>
                                            <Download className="w-4 h-4" /><span>صور الجوازات</span>
                                          </button>
                                        </div>
                                    </div>
                                </>
                            )}

                            {dateFilterType === 'consulate' && (
                                <>
                                    <div className="flex-1">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            من تاريخ دخول القنصلية
                                        </label>
                                        <input
                                            type="date"
                                            value={consulateStartDate}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setConsulateStartDate(value);
                                                handleSearch(search, startDate, endDate, companyFilter, 'consulate', value, consulateEndDate);
                                            }}
                                            className="w-full border border-gray-300 rounded-lg p-2"
                                        />
                                    </div>
                                    <div className="flex-1 w-full flex items-end gap-2">
                                        <div className="flex-1">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                إلى تاريخ دخول القنصلية
                                            </label>
                                            <input
                                                type="date"
                                                value={consulateEndDate}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setConsulateEndDate(value);
                                                    handleSearch(search, startDate, endDate, companyFilter, 'consulate', consulateStartDate, value);
                                                }}
                                                className="w-full border border-gray-300 rounded-lg p-2"
                                            />
                                        </div>
                                        <div className="flex items-end gap-2">
                                          <button onClick={() => setShowExportModal(true)} disabled={selectedPassports.length === 0}
                                            className={`px-3 py-2 rounded-lg flex items-center justify-center gap-2 text-sm whitespace-nowrap ${selectedPassports.length === 0 ? 'bg-gray-300 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'} text-white`}>
                                            <FileSpreadsheet className="w-4 h-4" /><span>تصدير إكسل</span>
                                          </button>
                                          <button onClick={exportPassportImages} disabled={selectedPassports.length === 0}
                                            className={`px-3 py-2 rounded-lg flex items-center justify-center gap-2 text-sm whitespace-nowrap ${selectedPassports.length === 0 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'} text-white`}>
                                            <Download className="w-4 h-4" /><span>صور الجوازات</span>
                                          </button>
                                        </div>
                                    </div>
                                </>
                            )}

                            {dateFilterType === 'travel' && (
                                <>
                                    <div className="flex-1">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            من تاريخ السفر
                                        </label>
                                        <input
                                            type="date"
                                            value={travelStartDate}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setTravelStartDate(value);
                                                handleSearch(search, startDate, endDate, companyFilter, 'travel', consulateStartDate, consulateEndDate, value, travelEndDate);
                                            }}
                                            className="w-full border border-gray-300 rounded-lg p-2"
                                        />
                                    </div>
                                    <div className="flex-1 w-full flex items-end gap-2">
                                        <div className="flex-1">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                                إلى تاريخ السفر
                                            </label>
                                            <input
                                                type="date"
                                                value={travelEndDate}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setTravelEndDate(value);
                                                    handleSearch(search, startDate, endDate, companyFilter, 'travel', consulateStartDate, consulateEndDate, travelStartDate, value);
                                                }}
                                                className="w-full border border-gray-300 rounded-lg p-2"
                                            />
                                        </div>
                                        <div className="flex items-end gap-2">
                                          <button onClick={() => setShowExportModal(true)} disabled={selectedPassports.length === 0}
                                            className={`px-3 py-2 rounded-lg flex items-center justify-center gap-2 text-sm whitespace-nowrap ${selectedPassports.length === 0 ? 'bg-gray-300 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'} text-white`}>
                                            <FileSpreadsheet className="w-4 h-4" /><span>تصدير إكسل</span>
                                          </button>
                                          <button onClick={exportPassportImages} disabled={selectedPassports.length === 0}
                                            className={`px-3 py-2 rounded-lg flex items-center justify-center gap-2 text-sm whitespace-nowrap ${selectedPassports.length === 0 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'} text-white`}>
                                            <Download className="w-4 h-4" /><span>صور الجوازات</span>
                                          </button>
                                        </div>
                                    </div>
                                </>
                            )}

                        </div>



                    </div>
                </div>
                {/* نتائج البحث والقائمة المحددة */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* نتائج البحث */}
                    <div className="bg-white rounded-lg shadow-md p-6">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-xl font-bold text-gray-900">نتائج البحث</h2>
                            
                            <button
                                onClick={handleAddAllFiltered}
                                className={`flex items-center gap-2 px-3 py-1.5 rounded-lg transition-colors ${
                                    filteredPassports.length === 0 
                                    ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                    : 'bg-blue-50 text-blue-600 hover:bg-blue-100'
                                }`}
                                disabled={filteredPassports.length === 0}
                            >
                                <Plus size={18} />
                                إضافة الكل
                                {filteredPassports.length > 0 && ` (${filteredPassports.length})`}
                            </button>
                        </div>
                        <div className="space-y-4 max-h-[600px] overflow-y-auto">
                            {filteredPassports.map(passport => (
                                <div 
                                    key={passport.PassportID}
                                    className="border rounded-lg p-4 hover:bg-gray-50 transition-colors"
                                >
                                    <div className="flex justify-between items-start">
                                        <div className="flex gap-4 w-full">
{passport.PassportImagePath && (
    <div className="relative group">
        <img
            src={buildImageUrl(passport.PassportImagePath)}
            alt="صورة الجواز"
            className="w-24 h-24 object-cover rounded-lg cursor-pointer"
            onClick={() => {
                const url = buildImageUrl(passport.PassportImagePath);
                setSelectedImage({
                    url,
                    title: `صورة جواز ${passport.NameArabic}`,
                    name: passport.NameArabic,
                    nameEnglish: passport.NameEnglish,
                    passportNumber: passport.PassportNumber
                });
                setShowImageViewer(true);
            }}
        />
        <button
            onClick={(e) => {
                e.stopPropagation();
                const link = document.createElement('a');
                link.href = buildImageUrl(passport.PassportImagePath);
                link.download = `جواز_${passport.NameArabic}.jpg`;
                link.click();
            }}
            className="absolute bottom-0 right-0 bg-black bg-opacity-50 p-1 rounded-bl-lg rounded-tr-lg opacity-0 group-hover:opacity-100 transition-opacity"
            title="تحميل الصورة"
        >
            <Download className="w-4 h-4 text-white" />
        </button>
    </div>
)}

                                            {/* البيانات */}
                                            <div className="flex-1">
                                                <h3 className="font-bold text-gray-900">{passport.NameArabic}</h3>
                                                <p className="text-gray-600">{passport.NameEnglish}</p>
                                                <div className="mt-2 space-y-1 text-sm text-gray-600">
                                                    <p>رقم الجواز: {passport.PassportNumber}</p>
                                                    <p>الرقم القومي: {passport.NationalID}</p>
                                                    <p>رقم الهاتف: {JSON.parse(passport.PhoneNumbers || '[]')[0]}</p>
                                                    <p>تاريخ التأشير: {passport.VisaDate ? 
                                                        new Date(passport.VisaDate).toLocaleDateString('ar-EG') : 
                                                        'غير محدد'}
                                                    </p>
                                                    <p>تاريخ السفر: {passport.TravelDate ? 
                                                        new Date(passport.TravelDate).toLocaleDateString('ar-EG') : 
                                                        'غير محدد'}
                                                    </p>
                                                </div>
                                            </div>
                                            
                                            {/* زر الإضافة */}
                                            <button
                                                onClick={() => handleAddPassport(passport)}
                                                className="bg-blue-50 text-blue-600 p-2 rounded-lg hover:bg-blue-100 transition-colors"
                                                disabled={selectedPassports.some(p => p.PassportID === passport.PassportID)}
                                            >
                                                <Plus className="w-5 h-5" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            
                            {filteredPassports.length === 0 && (
                                <div className="text-center text-gray-500 py-8">
                                    لم يتم العثور على نتائج
                                </div>
                            )}
                        </div>
                    </div>
                    {/* القائمة المحددة */}
                    <div className="bg-white rounded-lg shadow-md p-6">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-xl font-bold text-gray-900">
                                القائمة المحددة
                                {currentList && (
                                    <span className="text-sm font-normal text-gray-600 mr-2">
                                        ({currentList.ListName})
                                    </span>
                                )}
                            </h2>
                            <div className="flex gap-2">
                                {selectedPassports.length > 0 && (
                                    <button
                                        onClick={handleClearAll}
                                        className="text-red-600 hover:text-red-700 text-sm"
                                    >
                                        إزالة الكل
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="space-y-4 max-h-[600px] overflow-y-auto">
                            {selectedPassports.map(passport => (
                                <div 
                                    key={passport.PassportID}
                                    className="border rounded-lg p-4 bg-blue-50"
                                >
                                    <div className="flex justify-between items-start">
                                        <div>
                                            <h3 className="font-bold text-gray-900">{passport.NameArabic}</h3>
                                            <p className="text-gray-600">{passport.NameEnglish}</p>
                                            <div className="mt-2 space-y-1 text-sm text-gray-600">
                                                <p>رقم الجواز: {passport.PassportNumber}</p>
                                                <p>الرقم القومي: {passport.NationalID}</p>
                                                <p>رقم الهاتف: {JSON.parse(passport.PhoneNumbers || '[]')[0]}</p>
                                                <p>تاريخ التأشير: {passport.VisaDate ? 
                                                    new Date(passport.VisaDate).toLocaleDateString('ar-EG') : 
                                                    'غير محدد'}</p>
                                                <p>تاريخ السفر: {passport.TravelDate ? 
                                                    new Date(passport.TravelDate).toLocaleDateString('ar-EG') : 
                                                    'غير محدد'}</p>
                                            </div>
                                        </div>
                                        <button
                                            onClick={() => handleRemovePassport(passport.PassportID)}
                                            className="text-red-600 hover:text-red-700"
                                        >
                                            <X className="w-5 h-5" />
                                        </button>
                                    </div>
                                </div>
                            ))}
                            {selectedPassports.length === 0 && (
                                <div className="text-center text-gray-500 py-8">
                                    لم يتم تحديد أي جوازات بعد
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {/* القائمة الجانبية للكشوفات المحفوظة */}
                <div 
                    className={`fixed right-0 top-0 h-screen bg-white shadow-xl transition-transform duration-300 transform ${
                        showSavedLists ? 'translate-x-0' : 'translate-x-full'
                    }`} 
                    style={{ width: '400px' }}
                >
                    {/* زر إظهار/إخفاء القائمة */}
                    <button
                        onClick={() => setShowSavedLists(!showSavedLists)}
                        className="absolute top-1/2 right-full bg-white p-2 rounded-l-lg shadow-lg"
                    >
                        {showSavedLists ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
                    </button>

                    <div className="h-full flex flex-col p-4">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-xl font-bold">كشوفات الطيران المحفوظة</h2>
                            <button
                                onClick={() => {
                                    setCurrentList(null);
                                    setNewListData({ listName: '', flightDate: '', notes: '' });
                                    setShowSaveListModal(true);
                                }}
                                className="bg-blue-50 text-blue-600 p-2 rounded-lg hover:bg-blue-100"
                                title="إنشاء كشف جديد"
                            >
                                <Plus size={20} />
                            </button>
                        </div>

                        <div className="flex-1 overflow-auto">
                            {savedLists.length === 0 ? (
                                <div className="text-center text-gray-500 py-8">
                                    لا توجد كشوفات محفوظة
                                </div>
                            ) : (
                                savedLists.map(list => (
                                    <div
                                        key={list.ListID}
                                        className={`mb-3 p-4 rounded-lg border ${
                                            currentList?.ListID === list.ListID 
                                                ? 'bg-blue-50 border-blue-200' 
                                                : 'bg-gray-50 border-gray-200'
                                        } hover:bg-gray-100 transition-colors`}
                                    >
                                        <div className="flex justify-between items-start mb-2">
                                            <h3 className="font-semibold text-gray-900">{list.ListName}</h3>
                                            <div className="flex items-center gap-1">
                                                <button
                                                    onClick={() => handleDeleteList(list.ListID)}
                                                    className="text-red-500 hover:text-red-600 p-1"
                                                    title="حذف الكشف"
                                                >
                                                    <Trash2 size={16} />
                                                </button>
                                            </div>
                                        </div>
                                        <div className="text-sm text-gray-600">
                                            <p>تاريخ الطيران: {new Date(list.FlightDate).toLocaleDateString('ar-EG')}</p>
                                            <p>عدد الجوازات: {list.PassportsCount}</p>
                                            <p className="text-xs text-gray-500">
                                                تاريخ الإنشاء: {new Date(list.CreatedDate).toLocaleDateString('ar-EG')}
                                            </p>
                                            {list.Notes && (
                                                <p className="mt-2 text-xs text-gray-500">
                                                    ملاحظات: {list.Notes}
                                                </p>
                                            )}
                                        </div>
                                        <div className="mt-3 flex gap-2">
                                            <button
                                                onClick={() => loadList(list.ListID)}
                                                className="flex-1 bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700"
                                            >
                                                تحميل
                                            </button>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
                {/* مودال حفظ/تعديل الكشف */}
                {showSaveListModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                        <div className="bg-white rounded-lg p-6 w-[500px]">
                            <div className="flex justify-between items-center mb-4">
                                <h3 className="text-lg font-semibold">
                                    {currentList ? 'تعديل الكشف' : 'حفظ كشف جديد'}
                                </h3>
                                <button
                                    onClick={() => setShowSaveListModal(false)}
                                    className="text-gray-500 hover:text-gray-700"
                                >
                                    <X size={20} />
                                </button>
                            </div>

                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium mb-1">
                                        اسم الكشف <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        value={newListData.listName}
                                        onChange={(e) => setNewListData({ 
                                            ...newListData, 
                                            listName: e.target.value 
                                        })}
                                        className="w-full border rounded-lg p-2"
                                        placeholder="اسم الكشف"
                                        required
                                    />
                                </div>



                                <div>
                                    <label className="block text-sm font-medium mb-1">
                                        تاريخ الطيران <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        value={newListData.flightDate}
                                        onChange={(e) => setNewListData({ 
                                            ...newListData, 
                                            flightDate: e.target.value 
                                        })}
                                        className="w-full border rounded-lg p-2"
                                        required
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium mb-1">
                                        ملاحظات
                                    </label>
                                    <textarea
                                        value={newListData.notes}
                                        onChange={(e) => setNewListData({ 
                                            ...newListData, 
                                            notes: e.target.value 
                                        })}
                                        className="w-full border rounded-lg p-2 h-24 resize-none"
                                        placeholder="أي ملاحظات إضافية..."
                                    />
                                </div>

                                <div className="bg-gray-50 p-3 rounded-lg">
                                    <p className="text-sm text-gray-600">
                                        عدد الجوازات المحددة: {selectedPassports.length}
                                    </p>
                                </div>

                                <div className="flex justify-end gap-2 mt-6">
                                    <button
                                        onClick={currentList ? handleUpdateList : handleSaveList}
                                        disabled={selectedPassports.length === 0 || !newListData.listName || !newListData.flightDate}
                                        className={`px-6 py-2 rounded-lg ${
                                            selectedPassports.length === 0 || !newListData.listName || !newListData.flightDate
                                            ? 'bg-gray-300 cursor-not-allowed'
                                            : 'bg-blue-600 hover:bg-blue-700'
                                        } text-white`}
                                    >
                                        {currentList ? 'تحديث' : 'حفظ'}
                                    </button>
                                    <button
                                        onClick={() => setShowSaveListModal(false)}
                                        className="bg-gray-100 text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-200"
                                    >
                                        إلغاء
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* مودال التصدير إلى Excel */}
                {showExportModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                        <div className="bg-white rounded-lg p-6 w-[500px]">
                            <div className="flex justify-between items-center mb-4">
                                <h3 className="text-lg font-semibold">تحديد الأعمدة للتصدير</h3>
                                <button
                                    onClick={() => setShowExportModal(false)}
                                    className="text-gray-500 hover:text-gray-700"
                                >
                                    <X size={20} />
                                </button>
                            </div>

                            <div className="space-y-3">
                                {Object.entries({
                                    serialNumber: 'الرقم التسلسلي',
                                    nameArabic: 'الاسم بالعربي',
                                    nameEnglish: 'الاسم بالإنجليزي',
                                    passportNumber: 'رقم الجواز',
                                    nationalId: 'الرقم القومي',
                                     delegateName: 'المندوب',           
                                    militaryStatus: 'الموقف من التجنيد',
                                    phoneNumber: 'رقم الهاتف',
                                    visaDate: 'تاريخ التأشير',
                                    travelDate: 'تاريخ السفر'
                                }).map(([key, label]) => (
                                    <label key={key} className="flex items-center gap-2 hover:bg-gray-50 p-2 rounded">
                                        <input
                                            type="checkbox"
                                            checked={exportColumns[key]}
                                            onChange={(e) => setExportColumns(prev => ({
                                                ...prev,
                                                [key]: e.target.checked
                                            }))}
                                            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                        />
                                        <span className="text-gray-700">{label}</span>
                                    </label>
                                ))}
                            </div>

                            <div className="flex justify-end gap-2 mt-6">
                                <button
                                    onClick={() => {
                                        setShowExportModal(false);
                                        exportToExcel();
                                    }}
                                    className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 flex items-center gap-2"
                                >
                                    <FileSpreadsheet size={18} />
                                    تصدير
                                </button>
                                <button
                                    onClick={() => setShowExportModal(false)}
                                    className="bg-gray-100 text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-200"
                                >
                                    إلغاء
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* مودال عرض الصورة */}
                {showImageViewer && selectedImage && (
                    <div className="fixed inset-y-0 left-0 w-1/2 bg-white shadow-2xl z-50 transition-all duration-300 transform">
                        <div className="h-full flex flex-col">
                            {/* رأس المودال */}
                            <div className="flex items-center justify-between p-4 border-b">
                                <h3 className="text-xl font-semibold text-gray-900">
                                    {selectedImage.title}
                                </h3>
                                <div className="flex items-center gap-2">
                                    <button
                                        onClick={() => {
                                            const link = document.createElement('a');
                                            link.href = selectedImage.url;
                                            link.download = `جواز_${selectedImage.name}.jpg`;
                                            link.click();
                                        }}
                                        className="bg-blue-50 hover:bg-blue-100 text-blue-600 p-2 rounded-lg transition-colors"
                                        title="تحميل الصورة"
                                    >
                                        <Download size={20} />
                                    </button>
                                    <button
                                        onClick={() => setShowImageViewer(false)}
                                        className="bg-gray-50 hover:bg-gray-100 text-gray-600 p-2 rounded-lg transition-colors"
                                    >
                                        <X size={20} />
                                    </button>
                                </div>
                            </div>

                            {/* محتوى الصورة */}
                            <div className="flex-1 overflow-auto p-4">
                              <div className="relative h-full w-full flex items-center justify-center bg-gray-50 rounded-lg">
    <ImageMagnifier
        src={selectedImage.url}
        alt={selectedImage.title}
        className="max-w-full max-h-full object-contain"
        magnifierHeight={220}
        magnifierWidth={220}
        zoomLevel={1.8}
    />
</div>

                            </div>

                            {/* قسم التحقق من البيانات */}
                            <div className="p-4 border-t bg-gray-50">
                                <h4 className="font-medium text-gray-700 mb-4">التحقق من صحة البيانات:</h4>
                                <div className="space-y-3">
                                    <div className="p-2 bg-white rounded-lg shadow-sm">
                                        <p className="text-xs text-gray-500 mb-1">الاسم بالعربي</p>
                                        <p className="font-semibold text-gray-900">{selectedImage.name}</p>
                                    </div>
                                    <div className="p-2 bg-white rounded-lg shadow-sm">
                                        <p className="text-xs text-gray-500 mb-1">الاسم بالإنجليزي</p>
                                        <p className="font-semibold text-gray-900">{selectedImage.nameEnglish}</p>
                                    </div>
                                    <div className="p-2 bg-white rounded-lg shadow-sm">
                                        <p className="text-xs text-gray-500 mb-1">رقم الجواز</p>
                                        <p className="font-semibold text-gray-900 font-mono">{selectedImage.passportNumber}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FlightReport;